module.exports = __webpack_public_path__ + "img/work2.342d0255.png";